import React, { useEffect, useState } from 'react'
import { ASSET_TABS_LABELS, ASSET_TABS } from '../utils/constants'

import './Menu.scss'

const Menu = ({ className = '', currentTab, tabs, onSwitchTab }) => {
    const [_tabs, _setTabs] = useState([ASSET_TABS.TAB_MY_LIBRARY, ASSET_TABS.TAB_UNSPLASH_LIBRARY])

    useEffect(() => {
        if (tabs) {
            _setTabs(tabs)
        }
    }, [tabs])

    const switchTab = tab => {
        if (tab !== currentTab) {
            onSwitchTab(tab)
        }
    }

    return (
        <div className={`asset-menu ${className}`}>
            {_tabs.map(tab => (
                <div className={`asset-menu__tab ${tab === currentTab ? 'asset-menu__tab_active' : ''}`} key={tab}>
                    <span onClick={() => switchTab(tab)}>{ASSET_TABS_LABELS[tab]}</span>
                </div>
            ))}
        </div>
    )
}

export default Menu
